<template>
  <div class="productIntroductionTemplateParamEdit">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        :title="productIntroductionTemplateParam.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="400px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="productIntroductionTemplateParam"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div v-if="type===10">
          <el-form-item label="参数标题">
            <el-input v-model="productIntroductionTemplateParam.paramName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="参数类型">
            <el-select v-model.trim="productIntroductionTemplateParam.paramValueType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.paramValueType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="参数值">
            <el-input v-model="productIntroductionTemplateParam.paramValue" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div v-if="type===20">
          <el-form-item label="表头名称">
            <el-input v-model="productIntroductionTemplateParam.paramName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="参数值">
            <el-input v-model="productIntroductionTemplateParam.paramValue" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"ProductIntroductionTemplateParamEdit",
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        index: "",
        type: "",
        productIntroductionTemplateParam: {
          pkid: "",
          masterPKID: "",
          paramIndex: "",
          paramName: "",
          paramValueType: "",
          paramValue: "",
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(row,index,type) {
        this.index = index;
        this.type = type;
        this.dialogVisible = true;
        if(row) {
          this.productIntroductionTemplateParam = row;
        }
      },
      handleSubmit() {
        if(this.index<0) {
          this.dialogVisible = false;
          this.$emit("save-success",this.productIntroductionTemplateParam,-1,this.type);
        }else {
          this.dialogVisible = false;
          this.$emit("save-success",this.productIntroductionTemplateParam,this.index,this.type);
        }
      },
    },
  };
</script>

<style lang="scss">
  .productIntroductionTemplateParamEdit{
    .el-textarea{
      height: 150px!important;
    }
    .el-textarea__inner{
      height: 100%;
    }
  }
</style>
